import { render, staticRenderFns } from "./modularChild4.vue?vue&type=template&id=72dead85&scoped=true"
import script from "./modularChild4.vue?vue&type=script&lang=js"
export * from "./modularChild4.vue?vue&type=script&lang=js"
import style0 from "./modularChild4.vue?vue&type=style&index=0&id=72dead85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dead85",
  null
  
)

export default component.exports